// extracted by mini-css-extract-plugin
export default {"container":"form-column_container__kkaYI","truncate-table":"form-column_truncate-table__So+2x","table-text-faded":"form-column_table-text-faded__oJcNp","formRow":"form-column_formRow__699dl","formRowWrapper":"form-column_formRowWrapper__hFHqj","formRowItem":"form-column_formRowItem__GnAo3"};
    if(module.hot) {
      // 1792500640721
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  